import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://takingoverhvac.netlify.app';
const BUSINESS_NAME = 'Taking Over Contracting Inc';
const PHONE = '(253) 501-7893';

const SEOHead = ({
  title,
  description,
  keywords,
  canonicalPath = '',
  type = 'website',
  jsonLd,
}) => {
  const fullTitle = title
    ? `${title} | ${BUSINESS_NAME}`
    : `${BUSINESS_NAME} | HVAC, Heating & Air Conditioning Contractor | Pierce County, WA`;
  const canonicalUrl = `${SITE_URL}${canonicalPath}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={BUSINESS_NAME} />
      <meta property="og:locale" content="en_US" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}

      {/* JSON-LD Structured Data */}
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
};

export { SITE_URL, BUSINESS_NAME, PHONE };
export default SEOHead;
